// const {Urls} = require(BUILD_ENV == "prod" ? "./prodConstants": BUILD_ENV == "dr" ? "./drConstants" : "./demoConstants")
// const { Urls } = BUILD_ENV === "prod" ? require("./prodConstants") : {};
const {Urls} = require(BUILD_ENV == "prod" ? "./prodConstants": "./drConstants")

export {
  Urls
}
